module.exports = __webpack_public_path__ + "img/access-active.f863b97b.svg";